import { Injectable } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { queryProcessor } from '../../../model/dynamicForm/queryProcessor';

@Injectable({
  providedIn: 'root'
})
export class QueryFormService {

  constructor() { }

  toFormGroup(queries: queryProcessor<any>[] ) {
    let group: any = {};

    queries.forEach(query => {
      group[query.placeHolder] = query.required ? new FormControl('', Validators.required): new FormControl('');
      // group[query.placeHolder] = new FormControl(query.value || '');
    });
    return new FormGroup(group);
  }
}
